/* eslint-disable no-use-before-define */
import {
    MultiAnalytics,
    trackerIds,
} from '@zg-rentals/analytics-js';

import StringConstants from 'app/shared/constants/StringConstants';

let instance = null;

const logger = global.log.child({ name: 'multiAnalyticsModule' });

/*
 * MultiAnalyticsModule
 *
 * usage example:
 * const ma = new MultiAnalyticsModule().init({
        brand,
        isProd: false,
    }).getMa();
 */

// We want to test GA on the sherman test server
// temporarily override drymode value while testing
// revert before we release to production
// FIXME: set overrideDryMode to be null to disable
const overrideDryModeToBe = false;

class MultiAnalyticsModule {
    constructor() {
        if (!instance) {
            instance = this;
        }

        return instance;
    }

    init({
        brand,
        isProd,
        drymode = false,
    }) {
        this.brand = brand;
        this.isProd = isProd;
        this.drymode = drymode;
        this.trackersInUse = {
            gtm: '',
            ua: '',
            comscore: '',
        };

        if (!brand) {
            return console.error('ERROR@ MultiAnalytics: brand must be set');
        }

        const ids = [];

        // add gtm based in env
        if (this.isProd) {
            const gtm = trackerIds.ids.gtm.prod;
            const comscore = trackerIds.ids.comscore.prod;

            ids.push(gtm);
            this.trackersInUse.gtm = gtm;

            ids.push(comscore);
            this.trackersInUse.comscore = comscore;

            if (brand === StringConstants.UNFORMATTED_BRAND_NAMES.zillow) {
                const ua = trackerIds.ids.ua.zrm;

                ids.push(ua);
                this.trackersInUse.ua = ua;
            }
        } else {
            const gtm = trackerIds.ids.gtm.dev;

            ids.push(gtm);
            this.trackersInUse.gtm = gtm;
        }

        logger.debug({ ids, isProd, brand }, 'creating MultiAnalytics with trackerids');


        this.ma = new MultiAnalytics({
            ids,
            drymode: overrideDryModeToBe !== null ? overrideDryModeToBe : drymode,
            logger,
        });

        return instance;
    }

    static getInstance() {
        if (!instance) {
            console.error('ERROR@MultiAnalytics: no instance created');
        }

        return instance;
    }

    getMa() {
        return this.ma;
    }

    getTrackerIds() {
        return this.trackersInUse;
    }
}

export default MultiAnalyticsModule;
